import { SxProps } from '@mui/material';

export const sxPaVirtualTitle: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "24px",
  fontWeight: 700,
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "left"
}

export const sxPaVirtualSubtitle: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C'
}

export const sxPaVirtualUnavailable: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 400,
  textAlign: "left",
  color: '#4C4C4C',
  '@media (min-width: 1280px)': {
    width: '50%'
  }
}

export const sxButton: SxProps = {
  fontFamily: 'Unimed-Sans',
  borderRadius: '80px',
  padding: '12px 32px ',
  '@media (min-width: 374px)': {
    'textWrap': 'no-wrap'
  }
}

export const sxCheckbox: SxProps = {
  '.MuiFormControlLabel-label': {
    fontSize: '14px',
    color: '#4C4C4C',
    fontFamily: 'Unimed-Sans',
  }
}

export const sxScreeningFormLabel: SxProps = {
  fontFamily: "Unimed-Sans",
  fontSize: "16px",
  fontWeight: 600,
  lineHeight: "24px",
  letterSpacing: "0em",
  textAlign: "left",
  color: '#4C4C4C',
  "&.Mui-focused": {
    color: "#4C4C4C",
  },
  marginBottom: '20px',
  '@media (max-width: 475px)': {
    width: '100%'
  }
}

export const sxScreeningRadioGroup: SxProps = {
  gap: '100px',
  '@media (max-width: 475px)': {
    gap: 'unset',
    justifyContent: 'space-between',
    width: '100%'
  }
}

export const sxBoxScreening: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '25px'
}

export const sxRadioCitiesBox: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start'
}

export const sxRadioGroupStates: SxProps = {
  display: 'grid',
  columnGap: '30px',
  gridTemplateColumns: 'repeat(2, 1fr)'
}

export const sxAutocomplete: SxProps = {
  '.MuiOutlinedInput-root': {
    padding: '4px 4px 7.5px 5px',
    fontFamily: 'Unimed-Sans'
  }
}

export const sxTypographyAdvice: SxProps = {
  color: '#5F5F5F',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
  color: '#383838',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '150%',
}

export const sxCalendar: SxProps = {
  width: '100%',
  ".MuiDateCalendar-root": {
    backgroundColor: '#00995D',
    boxShadow: '0px 4px 8px 0px rgba(0, 0, 0, 0.08);'
  },
  ".MuiPickersCalendarHeader-root": {
    backgroundColor: '#00995D',
    color: '#fff',
    textTransform: 'uppercase',
    borderRadius: '10px 10px 0px 0px',
    paddingTop: '15px',
    paddingBottom: '15px',
    margin: '0',
    maxHeight: 'none',
  },
  ".MuiPickersCalendarHeader-labelContainer": {
    fontFamily: 'Unimed-Sans',
    fontWeight: '700',

  },
  ".MuiDayCalendar-root": {
    backgroundColor: "#fff"
  },
  ".MuiPickersCalendarHeader-switchViewButton": {
    color: '#fff'
  },
  ".MuiPickersArrowSwitcher-button": {
    color: '#fff'
  },
  ".MuiDayCalendar-weekDayLabel": {
    fontFamily: 'Unimed-Sans',
    fontWeight: '700',
    color: '#4C4C4C'
  },
  ".MuiPickersDay-root": {
    fontFamily: 'Unimed-Sans',
    color: '#4C4C4C',
    backgroundColor: '#90CAA6'
  },
  "MuiPickersDay-root:focus": {
    backgroundColor: '#00995D'
  },
  "MuiPickersDay-root:hover": {
    backgroundColor: '#00995D'
  },
  ".MuiPickersYear-yearButton": {
    fontFamily: 'Unimed-Sans',
    color: '#4C4C4C'
  },
  ".Mui-selected": {
    backgroundColor: '#00995D',
    color: "#fff"
  },
  ".Mui-selected:focus": {
    backgroundColor: '#00995D'
  },
  ".Mui-selected:hover": {
    backgroundColor: '#00995D'
  },
  ".Mui-disabled": {
    background: 'none'
  },
  '.MuiButton:hover .MuiButton-contained': {
    backgroundColor: '#00995D',
  }
}

export const sxRadio: SxProps = {
  '.MuiFormControlLabel-label': {
    fontSize: '14px'
  }
}

export const sxCircularLoadingProgress: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}

export const sxLabel: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 600,
}

export const sxInputEmail: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '400px'
}

export const sxInputPhone: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#383838',
  fontWeight: 400,
  fontSize: '14px',
  maxWidth: '200px'
}

export const sxError: SxProps = {
  color: '#D84141',
  fontSize: '12px'
}

export const sxSelectedCityInfo: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#717171',
  'textWrap': 'nowrap',
  fontWeight: 400,
  fontSize: '14px',
  paddingTop: '1px',
  maxWidth: '400px',
}

export const sxBoxInsideCoverageCitiesButton: SxProps = {
  display: "flex",
  marginTop: '3px',
  marginBottom: '25px',
  paddingLeft: '30px',
  flexDirection: "row", 
  width: '100%',
  rowGap: '5px',
  columnGap: '10px',
  flexWrap: 'wrap',
  '@media (min-width: 500px)': {
    width: '340px'
  }
}